import script from "./BaseButtons.vue?vue&type=script&lang=js"
export * from "./BaseButtons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__